import { EnumHashParameterStore } from 'blocks/hash_parameter';

export const BREAKPOINTS = ['desktop', 'tablet', 'mobile'] as const;
export type Breakpoint = (typeof BREAKPOINTS)[number];

export const breakpointStore = new EnumHashParameterStore<Breakpoint>(
  'breakpoint',
  BREAKPOINTS,
  'desktop',
);

export const BREAKPOINT_SIZE: Record<
  Breakpoint,
  { width: number; height: number }
> = {
  desktop: { width: 1440, height: 880 },
  tablet: { width: 810, height: 880 },
  mobile: { width: 390, height: 720 },
};

export const BREAKPOINT_TO_CANVAS_SCALE = 1080 / 1440;
